module.exports = "/_next/static/images/TwilioSegment@2x-e18b7c8dd6b6e3544d33743ebe0c1336.png";